import React, { useState, useEffect } from "react";
import { MainContainer } from "./Scrollbar.styles";

const Scrollbar = () => {
  const [scrollPercent, setScrollPercent] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scroll = window.scrollY;
      const dh = document.documentElement.scrollHeight;
      const wh = window.innerHeight;
      const newScrollPercent = (scroll / (dh - wh)) * 100;
      setScrollPercent(newScrollPercent);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <MainContainer id="progressbar" style={{ height: `${scrollPercent}%` }} />
  );
};

export default Scrollbar;
